import React from 'react'
import { createUseStyles } from 'react-jss'

import { ReactComponent as CloseIcon } from '../assets/CloseIcon.svg'
import { LG } from '../constants/mediaQueries'

const useStyles = createUseStyles({
  modal: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    padding: 20,
    borderRadius: 5,
    minWidth: 250,
    minHeight: 250,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    [LG]: {
      minWidth: 382,
      minHeight: 306
    }
  },
  closeButton: {
    position: 'absolute',
    top: 20,
    right: 20,
    padding: 5,
    background: 'transparent',
    border: 'none',
    color: 'white',
    cursor: 'pointer'
  }
})

const Modal = ({ children, visible, onClose }) => {
  if (!visible) return null
  const classes = useStyles()
  return (
    <div className={classes.modal}>
      <div className={classes.content}>
        <button className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </button>
        {children}
      </div>
    </div>
  )
}

export default Modal
